import React from "react";
import { createPluggable } from "pluggable-react";
import LucideIcon from "./LucideIcon";

export interface IconData {
  id: string;
  label: string;
}

export const ICONS = {
  close: { id: "close", label: "Close" },
  search: { id: "search", label: "Search" },
  add: { id: "add", label: "Add" },
  "expand-section": { id: "expand-section", label: "Expand Section" },
  "collapse-section": { id: "collapse-section", label: "Collapse Section" },
  submenu: { id: "submenu", label: "Submenu" },
  "tree-expand": { id: "tree-expand", label: "Expand Tree Node" },
  download: { id: "download", label: "Download" },
  selected: { id: "selected", label: "Selected" },
  "radio-selected": { id: "radio-selected", label: "Radio Selected" },
  "show-more": { id: "show-more", label: "Show More" },
  "show-data": { id: "show-data", label: "Show Data" },
  refresh: { id: "refresh", label: "Refresh" },
  undo: { id: "undo", label: "Undo" },
  redo: { id: "redo", label: "Redo" },
  history: { id: "history", label: "History" },
  help: { id: "help", label: "Help" },
  edit: { id: "edit", label: "Edit" },
  value: { id: "value", label: "Value" },
  error: { id: "error", label: "Error" },
  maximize: { id: "maximize", label: "Maximize" },
  minimize: { id: "minimize", label: "Minimize" },
  "expand-pane": { id: "expand-pane", label: "Expand Pane" },
  "collapse-pane": { id: "collapse-pane", label: "Collapse Pane" },
  save: { id: "save", label: "Save" },
  delete: { id: "delete", label: "Delete" },
  info: { id: "info", label: "Info" },
  settings: { id: "settings", label: "Settings" },
  filter: { id: "filter", label: "Filter" },
  copy: { id: "copy", label: "Copy" },
  "go-back": { id: "go-back", label: "Go back" },
  "go-forward": { id: "go-forward", label: "Go forward" },
  "go-first": { id: "go-first", label: "Go first" },
  "go-last": { id: "go-last", label: "Go last" },
  collapse: { id: "collapse", label: "Collapse" },
  expand: { id: "expand", label: "Expand" },
  check: { id: "check", label: "Check" },
  success: { id: "success", label: "Success" },
  warning: { id: "warning", label: "Warning" },
  "move-up": { id: "move-up", label: "Move up" },
  "move-down": { id: "move-down", label: "Move down" },
  "open-in-new": { id: "open-in-new", label: "Open In New" },
  reset: { id: "reset", label: "Reset" },
  sun: { id: "sun", label: "Sun" },
  moon: { id: "moon", label: "Moon" },
  monitor: { id: "monitor", label: "Monitor" },
  menu: { id: "menu", label: "Menu" },
  lock: { id: "lock", label: "Lock" },
  unlock: { id: "unlock", label: "Unlock" },
  minus: { id: "minus", label: "Minus" },
  star: { id: "star", label: "Star" },
  paste: { id: "paste", label: "Paste" },
  duplicate: { id: "duplicate", label: "Duplicate" },
  visibility: { id: "visibility", label: "Visibility" },
  "filter-list": { id: "filter-list", label: "Filter List" },
  code: { id: "code", label: "Code" },
  document: { id: "document", label: "Document" },
  play: { id: "play", label: "Play" },
  continue: { id: "continue", label: "Continue" },
  database: { id: "database", label: "Database" },
  adjust: { id: "adjust", label: "Adjust" },
  send: { id: "send", label: "Send" },
  "send-horizontal": { id: "send-horizontal", label: "Send Horizontal" },
  layers: { id: "layers", label: "Layers" },
  "import-file": { id: "import-file", label: "Import" },
  record: { id: "record", label: "Record" },
  approve: { id: "approve", label: "Approve" },
  reject: { id: "reject", label: "Reject" },
  "view-chart": { id: "view-chart", label: "View chart" },
  camera: { id: "camera", label: "Camera" },
  globe: { id: "globe", label: "Globe" },
  bell: { id: "bell", label: "Bell" },
  "credit-card": { id: "credit-card", label: "Credit Card" },
  "open-sidebar": { id: "open-sidebar", label: "Open sidebar" },
  "open-panel": { id: "open-panel", label: "Open panel" },
  resize: { id: "resize", label: "Resize" },
  "data-store": { id: "data-store", label: "Data store" },
  earth: { id: "earth", label: "Earth" },
  bug: { id: "bug", label: "Bug" },
  waypoints: { id: "waypoints", label: "Waypoints" },
  rotate: { id: "rotate", label: "Rotate" },
  relationship: { id: "relationship", label: "Relationship" },
  goal: { id: "goal", label: "Goal" },
  building: { id: "building", label: "Building" },
  package: { id: "package", label: "Package" },
  entity: { id: "entity", label: "Entity" },
  "date-range": { id: "date-range", label: "Date Range" },
  date: { id: "date", label: "Date" },
  clock: { id: "clock", label: "Time" },
  time: { id: "time", label: "Time" },
  person: { id: "person", label: "Person" },
  email: { id: "email", label: "Email" },
  "file-copy": { id: "copy", label: "Copy" },
  hide: { id: "hide", label: "Hide" },
  tag: { id: "tag", label: "Tag" },
  image: { id: "image", label: "Image" },
  drag: { id: "drag", label: "Drag" },
  trigger: { id: "trigger", label: "Trigger" },
  phone: { id: "phone", label: "Phone" },
  attach: { id: "attach", label: "Attach" },
  sort: { id: "sort", label: "Sort" },
  timeline: { id: "timeline", label: "Timeline" },
  message: { id: "message", label: "Message" },
  bold: { id: "bold", label: "Bold" },
  italic: { id: "italic", label: "Italic" },
  underline: { id: "underline", label: "Underline" },
  strikethrough: { id: "strikethrough", label: "Strikethrough" },
  stop: { id: "stop", label: "Stop" },
  flag: { id: "flag", label: "Flag" },
  slash: { id: "slash", label: "Slash" },
  text: { id: "text", label: "Text" },
  options: { id: "options", label: "Options" },
  radio: { id: "radio", label: "Radio" },
  number: { id: "number", label: "Number" },
  number_of_instances: { id: "number_of_instances", label: "Number Of Instances" },
  file: { id: "file", label: "File" },
  generative_chat: { id: "generative_chat", label: "Generative Chat" },
  repeating_container: { id: "repeating_container", label: "Repeating Container" },
  certainty_container: { id: "certainty_container", label: "Certainty Container" },
  switch_container: { id: "switch_container", label: "Switch Container" },
  data_container: { id: "data_container", label: "Data Container" },
  interview_container: { id: "interview_container", label: "Interview Container" },
  // Generated icons
  account: { id: "account", label: "Account" },
  "add-column-left": { id: "add-column-left", label: "Add Column Left" },
  "add-column-right": { id: "add-column-right", label: "Add Column Right" },
  "add-file": { id: "add-file", label: "Add File" },
  "add-group": { id: "add-group", label: "Add Group" },
  "add-header": { id: "add-header", label: "Add Header" },
  "add-row-below": { id: "add-row-below", label: "Add Row Below" },
  "add-row-top": { id: "add-row-top", label: "Add Row Top" },
  "add-rule": { id: "add-rule", label: "Add Rule" },
  "add-table": { id: "add-table", label: "Add Table" },
  analyst: { id: "analyst", label: "Analyst" },
  "arrow-down-right": { id: "arrow-down-right", label: "Arrow Down Right" },
  auto: { id: "auto", label: "Auto" },
  "auto-generate": { id: "auto-generate", label: "Auto Generate" },
  "auto-generate-pen": { id: "auto-generate-pen", label: "Auto Generate Pen" },
  billing: { id: "billing", label: "Billing" },
  boolean: { id: "boolean", label: "Boolean" },
  browse: { id: "browse", label: "Browse" },
  "browse-all": { id: "browse-all", label: "Browse All" },
  build: { id: "build", label: "Build" },
  "calendar-time": { id: "calendar-time", label: "Calendar Time" },
  checkbox: { id: "checkbox", label: "Checkbox" },
  citizenship: { id: "citizenship", label: "Citizenship" },
  clear: { id: "clear", label: "Clear" },
  compare: { id: "compare", label: "Compare" },
  currency: { id: "currency", label: "Currency" },
  dashboard: { id: "dashboard", label: "Dashboard" },
  datasheet: { id: "datasheet", label: "Datasheet" },
  debug: { id: "debug", label: "Debug" },
  "defined-in": { id: "defined-in", label: "Defined In" },
  "delete-column": { id: "delete-column", label: "Delete Column" },
  "delete-row": { id: "delete-row", label: "Delete Row" },
  dependency: { id: "dependency", label: "Dependency" },
  design: { id: "design", label: "Design" },
  designer: { id: "designer", label: "Designer" },
  developer: { id: "developer", label: "Developer" },
  documents: { id: "documents", label: "Documents" },
  dropdown: { id: "dropdown", label: "Dropdown" },
  equal: { id: "equal", label: "Equal" },
  "face-scan": { id: "face-scan", label: "Face Scan" },
  fingerprint: { id: "fingerprint", label: "Fingerprint" },
  "folder-filled": { id: "folder-filled", label: "Folder Filled" },
  "folder-open": { id: "folder-open", label: "Folder Open" },
  "form-screen": { id: "form-screen", label: "Form Screen" },
  "form-stage": { id: "form-stage", label: "Form Stage" },
  functions: { id: "functions", label: "Functions" },
  glossary: { id: "glossary", label: "Glossary" },
  guid: { id: "guid", label: "GUID" },
  "hide-files": { id: "hide-files", label: "Hide Files" },
  home: { id: "home", label: "Home" },
  id: { id: "id", label: "ID" },
  implementation: { id: "implementation", label: "Implementation" },
  indeterminate: { id: "indeterminate", label: "Indeterminate" },
  ingest: { id: "ingest", label: "Ingest" },
  innovate: { id: "innovate", label: "Innovate" },
  instances: { id: "instances", label: "Instances" },
  interactions: { id: "interactions", label: "Interactions" },
  interview: { id: "interview", label: "Interview" },
  label: { id: "label", label: "Label" },
  layout: { id: "layout", label: "Layout" },
  "less-equal": { id: "less-equal", label: "Less Equal" },
  "less-than": { id: "less-than", label: "Less Than" },
  "level-1": { id: "level-1", label: "Level 1" },
  "level-2": { id: "level-2", label: "Level 2" },
  "level-3": { id: "level-3", label: "Level 3" },
  "level-4": { id: "level-4", label: "Level 4" },
  "level-5": { id: "level-5", label: "Level 5" },
  "level-6": { id: "level-6", label: "Level 6" },
  linking: { id: "linking", label: "Linking" },
  location: { id: "location", label: "Location" },
  map: { id: "map", label: "Map" },
  matrix: { id: "matrix", label: "Matrix" },
  merge: { id: "merge", label: "Merge" },
  metadata: { id: "metadata", label: "Metadata" },
  "monitor-icon": { id: "monitor-icon", label: "Monitor" },
  "more-equal": { id: "more-equal", label: "More Equal" },
  "more-than": { id: "more-than", label: "More Than" },
  move: { id: "move", label: "Move" },
  "non-rule": { id: "non-rule", label: "Non Rule" },
  "not-equal": { id: "not-equal", label: "Not Equal" },
  notification: { id: "notification", label: "Notification" },
  outcome: { id: "outcome", label: "Outcome" },
  palette: { id: "palette", label: "Palette" },
  "pin-empty": { id: "pin-empty", label: "Pin Empty" },
  "pin-filled": { id: "pin-filled", label: "Pin Filled" },
  "private-link": { id: "private-link", label: "Private Link" },
  projects: { id: "projects", label: "Projects" },
  "public-link": { id: "public-link", label: "Public Link" },
  qr: { id: "qr", label: "QR" },
  "radio-button": { id: "radio-button", label: "Radio Button" },
  "redo-icon": { id: "redo-icon", label: "Redo" },
  reports: { id: "reports", label: "Reports" },
  "reset-graph": { id: "reset-graph", label: "Reset Graph" },
  retry: { id: "retry", label: "Retry" },
  "show-files": { id: "show-files", label: "Show Files" },
  signature: { id: "signature", label: "Signature" },
  slider: { id: "slider", label: "Slider" },
  snippet: { id: "snippet", label: "Snippet" },
  split: { id: "split", label: "Split" },
  "star-empty": { id: "star-empty", label: "Star Empty" },
  "star-filled": { id: "star-filled", label: "Star Filled" },
  subtract: { id: "subtract", label: "Subtract" },
  "system-file": { id: "system-file", label: "System File" },
  table: { id: "table", label: "Table" },
  "table-settings": { id: "table-settings", label: "Table Settings" },
  target: { id: "target", label: "Target" },
  tasks: { id: "tasks", label: "Tasks" },
  testing: { id: "testing", label: "Testing" },
  "text-field": { id: "text-field", label: "Text Field" },
  tooltip: { id: "tooltip", label: "Tooltip" },
  typography: { id: "typography", label: "Typography" },
  uncertain: { id: "uncertain", label: "Uncertain" },
  "undo-icon": { id: "undo-icon", label: "Undo" },
  unknown: { id: "unknown", label: "Unknown" },
  upload: { id: "upload", label: "Upload" },
  "upload-file": { id: "upload-file", label: "Upload File" },
  "user-roles": { id: "user-roles", label: "User Roles" },
  users: { id: "users", label: "Users" },
  verb: { id: "verb", label: "Verb" },
  verify: { id: "verify", label: "Verify" },
  "version-history": { id: "version-history", label: "Version History" },
  view: { id: "view", label: "View" },
  "zoom-in": { id: "zoom-in", label: "Zoom In" },
  "zoom-out": { id: "zoom-out", label: "Zoom Out" },
  "map-response": { id: "map-response", label: "Map Response" },
  "map-request": { id: "map-request", label: "Map Request" },
  "list-indent-increase": { id: "list-indent-increase", label: "List Indent Increase" },
  "list-indent-decrease": { id: "list-indent-decrease", label: "List Indent Decrease" },
  bookmark: { id: "bookmark", label: "Bookmark" },
  "keyboard-return": { id: "keyboard-return", label: "Keyboard Return" },
  list: { id: "list", label: "List" },
  "list-ordered": { id: "list-ordered", label: "List Ordered" },
  "cloud-download": { id: "cloud-download", label: "Cloud Download" },
  rename: { id: "rename", label: "Rename" },
  "more-horizontal": { id: "more-horizontal", label: "More" },
  "message-square-share": { id: "message-square-share", label: "Feedback" },
  "log-out": { id: "log-out", label: "Log Out" },
  "square-activity": { id: "square-activity", label: "Activity" },
  "settings-2": { id: "settings-2", label: "Preferences" },
  braces: { id: "braces", label: "Attribute" },
  quote: { id: "quote", label: "Quote" },
  link: { id: "link", label: "Link" },
  "heading-1": { id: "heading-1", label: "Heading 1" },
  "heading-2": { id: "heading-2", label: "Heading 2" },
  "heading-3": { id: "heading-3", label: "Heading 3" },
  "heading-4": { id: "heading-4", label: "Heading 4" },
  paragraph: { id: "paragraph", label: "Text" },
  "code-block": { id: "code-block", label: "Code block" },
  "align-left": { id: "align-left", label: "Align Left" },
  "align-center": { id: "align-center", label: "Align Center" },
  "align-right": { id: "align-right", label: "Align Right" },
  "align-justify": { id: "align-justify", label: "Justify" },
  unlink: { id: "unlink", label: "Remove link" },
  ban: { id: "ban", label: "None" },
  "code-xml": { id: "code-xml", label: "Code" },
  "square-text": { id: "square-text", label: "Text" },
} as const satisfies Record<string, IconData>;

export type IconName = keyof typeof ICONS;

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: IconName;
  fallbackName?: IconName;
  size?: number | string;
}

const Icon = createPluggable<IconProps>("deci.icon", LucideIcon);

export default Icon;
